module.exports = __webpack_public_path__ + "static/media/icon-humberger-menu.43f3e605.svg";